import { render } from "./StepHead.vue?vue&type=template&id=0cb2731a&scoped=true"
import script from "./StepHead.vue?vue&type=script&lang=js"
export * from "./StepHead.vue?vue&type=script&lang=js"

import "./StepHead.vue?vue&type=style&index=0&id=0cb2731a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb2731a"]])

export default __exports__